import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateNavbarHeading } from '../../../../constants/layout/store/filterSlice';
import { GetServiceCaller } from '../../../../services/serviceCaller';
import { API_URL } from '../../../../constants';
import Dynamic_PR_table from '../../../../components/Dynamic_PR_table';

const CreateProject = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("Projects"));
  }, [])


  const columns = {
    Clients: { text: "Client", align: "start", visible: true },
    ProjectName: { text: "Project Name", align: "start", visible: true },
    ProjectLocation: { text: "Location", align: "start", visible: true },
    ProjectAllocationTypeName: { text: "Type", align: "start", visible: true },
    StartDate: { text: "From", align: "center", visible: true },
    EndDate: { text: "To", align: "center", type: "HTML", visible: true },
  }
  const [apiStatus, SetApiStatus] = useState(undefined);

  useEffect(() => {
    fetchProjectListingData()
  }, [])
  const fetchProjectListingData = async () => {
    try {

      const response = await GetServiceCaller(`${API_URL}projectmanagement/project-listingdata`);


      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const fetchData = response?.data?.data;
        setProjectListData(fetchData)

      }
      else {
        console.error(
          "Failed to fetch asset categories. Server responded with status:",
          response
        );
      }
    }
    catch (error) {
      console.error("Fetching APi Error", error);

    }
  }

  const [searchTerm, setSearchTerm] = useState("");

  const [projectListdata, setProjectListData] = useState([])

  const handleAddNewCreateProject = () => {
    navigate(`/create-project/add`)
  }

  const handleEdit = (id) => {
    navigate(`/create-project/edit/${id.ID}`)
  }

  const handleAmendmentLog = (id) => {
    navigate(`/create-project/amendment_log/${id.ID}`)
  }

  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        <div className="row">
        <Dynamic_PR_table
          data={projectListdata}
          columns={columns}
          itemsPerPage={8}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          showIcon1={true}
          showIcon2={true}
          isApiStatus={apiStatus}
          isRequiredStatus={true}
          showIcon3={false}
          showIcon4={false}
          showIcon5={false}
          isActionRequired={true}
          isAddNewBtnRequired={true}
          handleIcon1={handleEdit}
          handleIcon2={handleAmendmentLog}
          handleAddNew={handleAddNewCreateProject}
          add
          more
          function
          icons={{
            Icon1: <i class="bi bi-pencil-square icons"></i>,
            Icon1Text: " Edit",
            // Icon1Flag:[],
            Icon2: <i class="bi bi-clock-history icons"></i>,
            Icon2Text: " Amendment Log",
          }}
        />
        </div>
      </div>
    </div>
  )
}

export default CreateProject